import React from "react"
import PropTypes from "prop-types"

const ShareIcon = ({ style }) => (
  <svg style={style} viewBox="0 0 12 15" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.092 11.826L3.538 9.775A2.5 2.5 0 0 1 .011 7.739L0 7.732l.01-.016a2.5 2.5 0 0 1 3.355-2.563l3.69-2.13A2.5 2.5 0 1 1 8.23 4.653L4.837 6.611a2.494 2.494 0 0 1 .05 1.632l3.495 2.019a2.5 2.5 0 1 1-1.291 1.564z"
      fill="currentColor"
      fillRule="evenodd" />
  </svg>
)

ShareIcon.propTypes = {
  style: PropTypes.object
}

export default ShareIcon



// WEBPACK FOOTER //
// ./src/components/icons/share-icon.jsx